import { useState, useEffect } from 'react';
import { useCustomerDetails } from '@hooks'

function SwellPointBalance({ customer }) {
  const [points, setPoints] = useState(0);
  const { customerDetails } = useCustomerDetails({
    email: customer?.email,
  });
  useEffect(() => {
    setPoints(customerDetails?.points_balance);
  }, [customerDetails?.points_balance]);

  return (
    <>
      {customer && (
        <div
          id="swell-customer-identification"
          data-authenticated="true"
          data-email={customer?.email}
          data-id={customer?.id?.replace('gid://shopify/Customer/', '')}
          data-tags='"[]"'
          style={{ display: 'none' }}
        />
      )}
      <span>{points}</span>
    </>
  );
}

export default SwellPointBalance;
